import { defineComponent as _defineComponent } from 'vue'
import currentUser from 'bits/current_user'
import { __ } from 'bits/intl'
import { storeToRefs } from 'pinia'
import { useWindowSizeStore } from 'pinia/window_size'

export default /*#__PURE__*/_defineComponent({
  __name: 'contact_header',
  setup(__props) {

const windowSizeStore = useWindowSizeStore()
const { isBiggerThanTabletLandscape } = storeToRefs(windowSizeStore)
let prefilledMessage = ''
if (currentUser == null || currentUser.name == null || currentUser.email == null) {
  prefilledMessage = __('User: Unknown\n----\nHi Padlet, ')
} else {
  prefilledMessage = __('User: %{name} - %{email}\n----\nHi Padlet, ', {
    name: currentUser.name || '',
    email: currentUser.email || '',
  })
}
const encodedPrefilledMessage = encodeURIComponent(prefilledMessage)
const subheading = __(
  "Submitting this form will help us respond to your request faster. If you don't find what you need, please feel free to send us an email at <a href='mailto:hello@padlet.com'>%{email}</a> or message us on WhatsApp at <a href='%{whatsappLink}' target='_blank'>+1-844-472-3538</a>. If <a href='https://padlet.com/' target='_blank' >%{padletPage}</a> is unavailable for you at the moment, please check out <a href='https://status.padlet.help/' target='_blank' >%{statusPage}</a> to see the current status of our site.",
  {
    email: 'hello@padlet.com',
    padletPage: 'padlet.com',
    statusPage: 'status.padlet.help',
    whatsappLink: `https://wa.me/18444723538?text=${encodedPrefilledMessage}`,
  },
)

return { __sfc: true,windowSizeStore, isBiggerThanTabletLandscape, prefilledMessage, encodedPrefilledMessage, subheading, __ }
}

})